:root {
	--dd-bg: #ffffff;
	--dd-fg: #111827;
	--dd-muted: #6b7280;
	--dd-border: #e5e7eb;
	--dd-hover: #f3f4f6;
	--dd-primary: #84bd44;
	--dd-ring: #84bd44;
	--dd-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1);

	--dd-danger: #ef4444;
	--dd-danger-hover: #fee2e2;
}

.dropdown {
	position: relative;
	display: inline-flex;
}

.iconButton {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	background: transparent;
	border: none;
	padding: 0;
	cursor: pointer;
	color: var(--dd-fg);

	&:hover {
		color: #374151;
	}
	&:focus-visible {
		outline: 2px solid var(--dd-ring);
		outline-offset: 2px;
		border-radius: 0.375rem;
	}
}

.dropdown[data-align="left"] .menu {
	left: 0;
	right: auto;
}
.dropdown[data-align="right"] .menu {
	right: 0;
	left: auto;
}

.menu {
	position: absolute;
	top: calc(100% + 0.5rem);
	min-width: 12rem;
	background: var(--dd-bg);
	color: var(--dd-fg);
	border: 1px solid var(--dd-border);
	border-radius: 0.75rem;
	box-shadow: var(--dd-shadow);
	z-index: 50;
	animation: dd-fade 0.12s ease-out;
}

.menuPortal {
	position: fixed;
	min-width: 12rem;
	background: var(--dd-bg);
	color: var(--dd-fg);
	border: 1px solid var(--dd-border);
	border-radius: 0.75rem;
	box-shadow: var(--dd-shadow);
	z-index: 9999;
	animation: dd-fade 0.12s ease-out;
}

@keyframes dd-fade {
	from {
		opacity: 0;
		transform: translateY(-4px) scale(0.98);
	}
	to {
		opacity: 1;
		transform: translateY(0) scale(1);
	}
}

@keyframes dd-fade-up {
	from {
		opacity: 0;
		transform: translateY(4px) scale(0.98);
	}
	to {
		opacity: 1;
		transform: translateY(0) scale(1);
	}
}

.openUpwards {
	animation: dd-fade-up 0.12s ease-out;
}

.header {
	padding: 0.3rem 0.4rem;
	border-bottom: 1px solid var(--dd-border);
}
.headerText {
	font-weight: 500;
	color: var(--dd-primary);
	letter-spacing: 0.01em;
	font-size: 14px;
}

.list {
	display: flex;
	flex-direction: column;
	gap: 0.125rem;
	padding: 0.25rem;
}

.item {
	display: flex;
	align-items: center;
	gap: 0.5rem;
	width: 100%;
	padding: 0.5rem 0.625rem;
	background: transparent;
	color: var(--dd-fg);
	border: 0;
	border-radius: 0.5rem;
	cursor: pointer;
	font-size: 0.875rem;

	&:hover {
		background: var(--dd-hover);
	}
	&:focus-visible {
		outline: 2px solid var(--dd-ring);
		outline-offset: 2px;
	}
}

.icon {
	flex: 0 0 auto;
}

.danger {
	color: var(--dd-danger);

	&:hover {
		background: var(--dd-danger-hover);
	}
}

.disabled {
	opacity: 0.5;
	cursor: not-allowed;

	&:hover {
		background: transparent;
	}
}
.separator {
	height: 1px;
	background: var(--dd-border);
	margin: 0.25rem 0;
}
